import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import PdfToImagePage from "@/pages/PdfToImagePage";
import ImageToPdfPage from "@/pages/ImageToPdfPage";
import PdfSplitPage from "@/pages/PdfSplitPage";
import PdfMergePage from "@/pages/PdfMergePage";
import PdfCompressPage from "@/pages/PdfCompressPage";
import PdfRotatePage from "@/pages/PdfRotatePage";
import PdfDeletePagesPage from "@/pages/PdfDeletePagesPage";
import PdfOrganizePage from "@/pages/PdfOrganizePage";
import PdfOcrPage from "@/pages/PdfOcrPage";
import PdfScannedPage from "@/pages/PdfScannedPage";
import PdfSignPage from "@/pages/PdfSignPage";
import PdfEditPage from "@/pages/PdfEditPage";
import PdfWatermarkPage from "@/pages/PdfWatermarkPage";
import PdfProtectPage from "@/pages/PdfProtectPage";
import PdfUnlockPage from "@/pages/PdfUnlockPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App noise-bg min-h-screen">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="pdf-to-image" element={<PdfToImagePage />} />
              <Route path="image-to-pdf" element={<ImageToPdfPage />} />
              <Route path="pdf-split" element={<PdfSplitPage />} />
              <Route path="pdf-merge" element={<PdfMergePage />} />
              <Route path="pdf-compress" element={<PdfCompressPage />} />
              <Route path="pdf-rotate" element={<PdfRotatePage />} />
              <Route path="pdf-delete-pages" element={<PdfDeletePagesPage />} />
              <Route path="pdf-organize" element={<PdfOrganizePage />} />
              <Route path="pdf-ocr" element={<PdfOcrPage />} />
              <Route path="pdf-scanned" element={<PdfScannedPage />} />
              <Route path="pdf-sign" element={<PdfSignPage />} />
              <Route path="pdf-edit" element={<PdfEditPage />} />
              <Route path="pdf-watermark" element={<PdfWatermarkPage />} />
              <Route path="pdf-protect" element={<PdfProtectPage />} />
              <Route path="pdf-unlock" element={<PdfUnlockPage />} />
              <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="contact" element={<ContactPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
